import { render, staticRenderFns } from "./EntriKkTidakValid.vue?vue&type=template&id=35397814&scoped=true"
import script from "./EntriKkTidakValid.vue?vue&type=script&lang=js"
export * from "./EntriKkTidakValid.vue?vue&type=script&lang=js"
import style0 from "./EntriKkTidakValid.vue?vue&type=style&index=0&id=35397814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35397814",
  null
  
)

export default component.exports